import { useContext, useEffect, useState } from 'react'
import CONFIG from 'configs/configs.js'
import { IResponse } from 'interfaces'
import { useFetch, useStorage } from 'hooks'
import { UserContext, GeneralContext } from 'context'
import { clearString, hasAccess, optionsLevels } from 'helper/utils'
import { Icon } from 'assets/index'

import {
  ActionCard,
  InfoCard,
  Loading,
  ResumeSelectCard,
  Path,
} from 'components/index'
import { Theme } from 'styles/Themes'
import { Container } from './style'

export default function HomeCliente() {
  const {
    clientOption,
    setClientOption,
    data = {},
    setData,
    selectedId,
  } = useContext(UserContext)
  const api = useFetch(`/gestor/account?id=${selectedId.current}`)
  const [specialist, setSpecialist] = useState<any>({})
  const [user] = useStorage('User')
  const [colaboradores] = useStorage('Colaboradores')
  // const [specialLoading, setSpecialLoading] = useState(false)
  // const specialistList = general.speciaList.get()
  // const all = general.gestor.get()

  useEffect(() => {
    // setLoading(true)
    const fetchData = async () => {
      try {
        const response: IResponse = await api.fetch('get')
        if (response.fail) throw new Error(response.errors.message)
        const info = response.data.data
        console.log('esses dados', info)

        if (info.account.status !== 'ACTIVE') {
          info.account.status =
            CONFIG.DICTIONARY.ACCOUNT[String(info?.account?.status)]
        }

        let spec = colaboradores.find(
          (item: any) => item.id === info.account.gestorId
        )
        if (!spec) {
          spec = {
            name: 'Selecionar',
            profilePic: 'profile_placeholder.png',
          }
        }
        // setSpecialist(
        //   all.find((item: any) => item.id === info.account.gestorId)
        // )
        setSpecialist(spec)
        setData(info, selectedId.current)
      } catch (err: any) {
        console.log('err', err)
      }
    }

    fetchData()
    // setLoading(false)
  }, [])

  function onChangeSpecialist(spe: any) {
    api
      .fetch(
        'post',
        { gestorId: spe.id },
        `/gestor/account/${clearString(data?.user?.document)}`
      )
      .then((r) => console.log(r))
      .catch(console.error)
    setSpecialist(spe)
  }

  const handleShowDetails = (value: string) => {
    if (clientOption === value) setClientOption('')
    else setClientOption(value)
  }

  if (Object.keys(data).length === 0) return <Loading modal />
  // return <Loading modal />
  return (
    <Container>
      <Path className="path">
        <span className="path">{'Detalhes do cliente'}</span>
      </Path>
      <h1 className="detalhes-captacao-title">{data?.user?.name}</h1>

      <div className="detalhes-container123">
        <h4 className="status-span">
          Conta{' '}
          {data?.user?.type === 'CPF' ? 'pessoa física' : 'pessoa jurídica'}
        </h4>
        <img
          className="status-icon"
          src={Icon('undefined.svg')}
          alt="status icon"
        />
        <span className="status-span">
          {data?.account?.status !== 'ACTIVE' && data?.account?.status}
        </span>
      </div>
      <div className="status-card-container-cards">
        <InfoCard icon={Icon('money.svg')} value={data?.wallet?.brl}>
          Saldo da conta digital
        </InfoCard>
        <InfoCard icon={Icon('invest.svg')} value={data?.wallet?.token}>
          Valor investido
        </InfoCard>
        <InfoCard icon={Icon('dollar.svg')} value={data?.wallet?.pendent}>
          Rentabilidade a receber
        </InfoCard>
      </div>

      <div className="status-card-container-cards">
        <ActionCard
          icon={Icon('building.svg')}
          value="Produtos"
          onClick={() => handleShowDetails('Produtos')}
        />
        <ActionCard
          icon={Icon('info.svg')}
          value="Informações"
          onClick={() => handleShowDetails('Informações')}
        />
        <ActionCard
          icon={Icon('extract.svg')}
          value="Extrato"
          onClick={() => handleShowDetails('Extrato')}
        />
        {/* {console.log(specialist)} */}
        {hasAccess('select-client-specialist') && (
          <ResumeSelectCard
            // loading={specialLoading}
            id={'select-client-specialist'}
            disabled={user?.permission === 'READ'}
            name={specialist?.name}
            specialist
            icon={`${CONFIG.IMAGES.URL}/images/${specialist?.profilePic}`} // specialist?.profilePic
            options={colaboradores.map((g: any) => {
              return {
                ...g,
                value: g,
                label: g.name,
                image: `${CONFIG.IMAGES.URL}/images/${g?.profilePic}`,
              }
            })}
            text=""
            handleChange={(item: any) => onChangeSpecialist(item.value)}
          >
            Especialista
          </ResumeSelectCard>
        )}
      </div>
    </Container>
  )
}
